import { type Color } from '@mui/material'

export const postYellow = {
  100: '#25200E',
  200: '#3D340F',
  300: '#6E5B12',
  400: '#9E8314',
  500: '#CFAA17',
  600: '#FFD119',
  700: '#FFDA47',
  800: '#FFE375',
  900: '#FFEDA3',
} satisfies Partial<Color>
